export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'defaultImageUrl',
    width: 100,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('INDEX.amz_sku_inv_goodsName') || '产品',
    field: 'goodsName',
    minWidth: 300,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('INDEX.amz_sku_inv_scmName') || '工厂',
    field: 'scmName',
    minWidth: 260,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayScmName' },
  },
  {
    title: that.$l('form_label_locationNo') || '厂库库位',
    field: 'locationNo',
    minWidth: 260,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayLocationNo' },
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ftyPrice') || '采购单价',
    field: 'ftyPrice',
    minWidth: 80,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_inCtnQty') || '箱入数',
    field: 'inCtnQty',
    minWidth: 60,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ctnQty') || '箱数',
    field: 'ctnQty',
    minWidth: 90,
    headerAlign: 'left',
    align: 'left',
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_goodsQty') || '产品数量',
    field: 'goodsQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_subAmount') || '成本小计',
    field: 'subAmount',
    minWidth: 120,
    headerAlign: 'left',
    align: 'left',
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_totalCtnCbm') || '总库存体积',
    field: 'totalCtnCbm',
    minWidth: 120,
    headerAlign: 'left',
    align: 'left',
    isTotalColumn: true,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('form_label_inboundDate') || '入库日期',
    field: 'inboundDate',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_poNo') || '订单编号',
    field: 'poNo',
    minWidth: 140,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ftyInvUpdateTime') || '国内库存更新时间',
    field: 'invUpdateTime',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
]
